import { Box, Typography, useTheme } from "@mui/material"
import { Link } from "react-router-dom"
import { useKidsAndFamily } from "extensions/em-kids-and-family/hooks/useKidsAndFamily"

import { PageCard, PageCardContent } from "components/card"
import { MotionDiv } from "components/motions"
import { AppNavigation } from "containers/AppNavigation"
import { NavigationControl } from "components/kioskHorizontal/navigation"
import { DirectoryOccupantCard } from "components/domains/directory/DirectoryOccupantCard"
import { PromotionCard } from "components/domains/promotions"
import { VerticalEventCard } from "components/domains/events"

const renderEventAndPromotionLinkCard = (feature) => {
  switch (feature?.feature_type) {
    case "promotion":
      return (
        <Link to={`/promotions/${feature?.id}`} key={feature.id}>
          <PromotionCard promotion={feature} />
        </Link>
      )
    case "event":
      return (
        <Link to={`/events/${feature?.id}`} key={feature.id}>
          <VerticalEventCard event={feature} />
        </Link>
      )
    default:
      return null
  }
}

export const EMKidsAndFamilyKioskHPage = ({ Layout = Box }) => {
  const { occupants, eventsAndPromotions } = useKidsAndFamily()
  const theme = useTheme()
  const styleOverrides =
    theme.components[`EmKidAndFamilyPage`]?.styleOverrides || {}
  const {
    container = {},
    title = {},
    sectionContentWrapper = {},
    occupantCardsContainer = {},
    occupantsSection = {},
    eventPromotionSection = {},
    eventPromotionCardsContainer = {},
  } = styleOverrides

  const bannerStyleOverrides =
    theme.components[`AppBanner`]?.styleOverrides || {}
  const sideBarStyleOverrides =
    theme.components[`AppSidebar`]?.styleOverrides || {}

  const { root } = bannerStyleOverrides
  const { wrapper, body, footer } = sideBarStyleOverrides

  return (
    <Layout
      aside={
        <PageCard>
          <Box sx={wrapper}>
            <Box sx={root}></Box>
            <Box sx={body}>
              <AppNavigation />
            </Box>
            <Box sx={footer}>
              <NavigationControl BackButtonProps={{ hidden: true }} />
            </Box>
          </Box>
        </PageCard>
      }
    >
      <Box sx={container}>
        <PageCard sx={occupantsSection}>
          <MotionDiv
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.15 }}
            sx={sectionContentWrapper}
          >
            <PageCardContent>
              <Typography variant="heading1" component="h1" sx={title}>
                KID’S AND FAMILY SHOP :
              </Typography>
              <Box sx={occupantCardsContainer}>
                {occupants.map((occupant) => (
                  <DirectoryOccupantCard key={occupant.id} data={occupant} />
                ))}
              </Box>
            </PageCardContent>
          </MotionDiv>
        </PageCard>

        <PageCard>
          <MotionDiv
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.15 }}
            sx={sectionContentWrapper}
          >
            <PageCardContent>
              <Typography variant="heading1" component="h1" sx={title}>
                EVENTS & PROMOTIONS :
              </Typography>
              <Box sx={eventPromotionSection}>
                <Box sx={eventPromotionCardsContainer}>
                  {eventsAndPromotions.map(renderEventAndPromotionLinkCard)}
                </Box>
              </Box>
            </PageCardContent>
          </MotionDiv>
        </PageCard>
      </Box>
    </Layout>
  )
}
